__turbopack_context__.v({
  "className": "_2xSZRq_className",
  "variable": "_2xSZRq_variable",
});
